export default __webpack_public_path__ + "static/media/qrCode.93d6d8ea.svg";